module.exports = __webpack_public_path__ + "img/rencai_normal.7e7ecd33.png";